module.exports = __webpack_public_path__ + "img/enerman-etisol.96b7e061.svg";